export const JOURNAL_LOGO_URL =
  `${process.env.REACT_APP_BACKEND_URL}/api/uploads/csr_logo.png`;

export const NAVY = "#001F3F";
export const TEAL = "#2BA6A6";
export const LIGHT_GRAY = "#F5F7FA";

export const MAIN_NAV = [
  { label: "Home", to: "/" },
  { label: "Current Issue", to: "/current-issue" },
  { label: "Articles", to: "/articles" },
  { label: "Submit", to: "/submit" },
  { label: "Authors", to: "/authors" },
  { label: "Editorial Board", to: "/editorial-board" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const ARTICLE_TYPES = [
  "Original Research",
  "Review Article",
  "Systematic Review",
  "Meta-analysis",
  "Case Report",
  "Case Series",
  "Clinical Study",
  "Surgical Technique",
  "Clinical Image",
  "Letter to the Editor",
  "Editorial",
];

export const SPECIALTIES = [
  // Internal medicine subspecialties
  "Internal Medicine",
  "Cardiology",
  "Endocrinology",
  "Gastroenterology",
  "Hematology",
  "Hepatology",
  "Infectious Diseases",
  "Nephrology",
  "Pulmonology",
  "Rheumatology",
  "Geriatrics",
  "Allergy and Immunology",
  "Medical Oncology",
  // Surgical subspecialties
  "General Surgery",
  "Cardiothoracic Surgery",
  "Vascular Surgery",
  "Neurosurgery",
  "Orthopedic Surgery",
  "Plastic and Reconstructive Surgery",
  "Pediatric Surgery",
  "Urology",
  "Otolaryngology (ENT)",
  "Ophthalmology",
  "Colorectal Surgery",
  "Hepato-Pancreato-Biliary Surgery",
  "Bariatric Surgery",
  "Trauma Surgery",
  "Surgical Oncology",
  "Transplant Surgery",
  "Minimally Invasive Surgery",
  // Other clinical
  "Oncology",
  "Critical Care",
  "Emergency Medicine",
  "Anesthesiology",
  "Gynecology and Obstetrics",
  "Pediatrics",
  "Neonatology",
  "Psychiatry",
  "Neurology",
  "Dermatology",
  "Radiology",
  "Pathology",
  "Nuclear Medicine",
  "Radiation Oncology",
  "Family Medicine",
  "Physical Medicine and Rehabilitation",
  "Public Health",
  "Other",
];

export const ACADEMIC_DEGREES = [
  "MD (Medical Doctor)",
  "MD, PhD (Medical Doctor, Doctor of Philosophy)",
  "DO (Doctor of Osteopathic Medicine)",
  "MBBS (Bachelor of Medicine, Bachelor of Surgery)",
  "PhD (Doctor of Philosophy)",
  "MSc (Master of Science)",
  "BSc (Bachelor of Science)",
  "RN (Registered Nurse)",
  "BSN (Bachelor of Science in Nursing)",
  "PharmD (Doctor of Pharmacy)",
  "DDS (Doctor of Dental Surgery)",
  "DMD (Doctor of Medicine in Dentistry)",
  "DVM (Doctor of Veterinary Medicine)",
  "MPH (Master of Public Health)",
  "MPH, MD (Master of Public Health, Medical Doctor)",
  "DSc (Doctor of Science)",
  "PA (Physician Assistant)",
  "NP (Nurse Practitioner)",
  "Resident",
  "Fellow",
  "Attending Physician",
  "Professor",
  "Associate Professor",
  "Assistant Professor",
  "Other",
];

export const DEPARTMENTS = [
  "Department of Internal Medicine",
  "Department of Surgery",
  "Department of General Surgery",
  "Department of Cardiothoracic Surgery",
  "Department of Vascular Surgery",
  "Department of Neurosurgery",
  "Department of Orthopedics",
  "Department of Urology",
  "Department of Otolaryngology",
  "Department of Ophthalmology",
  "Department of Plastic Surgery",
  "Department of Pediatric Surgery",
  "Department of Cardiology",
  "Department of Endocrinology",
  "Department of Gastroenterology",
  "Department of Hematology",
  "Department of Nephrology",
  "Department of Pulmonology",
  "Department of Rheumatology",
  "Department of Infectious Diseases",
  "Department of Oncology",
  "Department of Radiation Oncology",
  "Department of Anesthesiology",
  "Department of Emergency Medicine",
  "Department of Critical Care",
  "Department of Obstetrics and Gynecology",
  "Department of Pediatrics",
  "Department of Neonatology",
  "Department of Psychiatry",
  "Department of Neurology",
  "Department of Dermatology",
  "Department of Radiology",
  "Department of Pathology",
  "Department of Nuclear Medicine",
  "Department of Family Medicine",
  "Department of Rehabilitation",
  "Department of Public Health",
  "Department of Research",
  "Department of Medical Education",
  "Other",
];

export const BOARD_ROLES = [
  "Editor-in-Chief",
  "Associate Editor",
  "Section Editor",
  "Statistical Editor",
  "Ethics Editor",
  "Reviewer",
  "Advisory Board",
];

export const SUBMISSION_STATUSES = [
  "Submitted",
  "Under Editorial Review",
  "Sent to Peer Review",
  "Minor Revision",
  "Major Revision",
  "Accepted",
  "Rejected",
  "In Production",
  "Official PDF Draft",
  "Published",
];
